import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { InterviewMotivation } from './interview-motivation';
export { InterviewMotivation };
import { interviewMotivationSchema } from '@schemas/business-objects/interview-motivation';
import { InterviewFormGroup } from './interview-form-group';

export class InterviewMotivationFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    eventKnowledgeScore: SchemaFormControl;
    eventExperienceScore: SchemaFormControl;
    notes: SchemaFormControl;
    interviewId: SchemaFormControl;
    interview: InterviewFormGroup;
  };

  declare value: Partial<InterviewMotivation>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(interviewMotivationSchema, InterviewMotivation, data, options);
  }

  get object(): InterviewMotivation {
    return new InterviewMotivation(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'interview':
        return new InterviewFormGroup();
      default:
        return undefined;
    }
  }
}

export class InterviewMotivationFormArray extends PersistedFormArray {
  readonly entityName = 'InterviewMotivation' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(interviewMotivationSchema, InterviewMotivation, options);
  }

  protected override createItemGroup() {
    return new InterviewMotivationFormGroup();
  }

  get array(): InterviewMotivation[] {
    return this.controls.map(
      (group: InterviewMotivationFormGroup) => group.object,
    );
  }
}

export class InterviewMotivationPersistedArray extends PersistedArray<InterviewMotivation> {
  readonly entityName = 'InterviewMotivation' as const;

  constructor(options?: PersistedArrayOptions) {
    super(InterviewMotivation, options);
  }
}
